import Dimensi from "../../../../../components/categories/siakad/laporan_adab/penilaian/Home";
export default function Home() {
  
  return (
    <Dimensi />
  );
}
